import React from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';
import HairLineDivider from 'shared/components/vxl/divider/HairlineDivider/HairLineDivider';
import ListItem from 'shared/components/vxl/ListItem/ListItem';
import BodyBaseText from 'shared/components/vxl/typography/primary/body/BodyBaseText';
import BodyXSText from 'shared/components/vxl/typography/primary/body/BodyXSText';
import { VXLComponentId } from 'shared/renderer/types';
import theme from 'shared/styles/theme';

const ApplyNowContent = () => {
  const { t: translatedText } = useTranslation('payOverTime', {
    keyPrefix: 'applyNow',
  });

  return (
    <View>
      <BodyBaseText numberOfLines={0} style={styles.subTitle}>
        {translatedText('subTitle')}
      </BodyBaseText>
      <ListItem
        primaryCopy={translatedText('bullet1')}
        showsChevron={false}
        leadingAccessory={{
          id: 'CREDIT_SCORE_no_impact',
          name: VXLComponentId.ICON_AVATAR,
          props: {
            iconKey: 'CREDIT_SCORE',
          },
        }}
      />
      <View style={styles.hairLine}>
        <HairLineDivider />
      </View>
      <ListItem
        primaryCopy={translatedText('bullet2')}
        showsChevron={false}
        leadingAccessory={{
          id: 'STORE_finance_purchases',
          name: VXLComponentId.ICON_AVATAR,
          props: {
            iconKey: 'STORE',
          },
        }}
      />
      <View style={styles.hairLine}>
        <HairLineDivider />
      </View>
      <ListItem
        primaryCopy={translatedText('bullet3')}
        showsChevron={false}
        leadingAccessory={{
          id: 'MONEY_one_time_fee',
          name: VXLComponentId.ICON_AVATAR,
          props: {
            iconKey: 'MONEY',
          },
        }}
      />
      <BodyXSText style={styles.footer} numberOfLines={0}>
        {translatedText('footer')}
      </BodyXSText>
    </View>
  );
};

const styles = StyleSheet.create({
  footer: {
    color: theme.color.text.secondary,
    paddingHorizontal: theme.spacing.m,
    paddingVertical: theme.spacing.m,
  },
  hairLine: {
    paddingHorizontal: theme.spacing.m,
  },
  subTitle: {
    paddingBottom: theme.spacing.m,
    paddingHorizontal: theme.spacing.m,
    textAlign: 'center',
  },
});

export default ApplyNowContent;
